import React, {
  useEffect, useState,
} from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { LinearProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import calculateProgress from '../functions/calculateProgress';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },
  linearProgress: {
    height: '10px',
    '.rtl &': {
      transform: 'rotate(180deg)',
    },
    backgroundColor: 'rgba(242,242,247,1) !important',
  },
}));

/**
 * The general progress of the currently opened questionnaire
 */
const QuestionnaireProgress = ({ profile }) => {
  const { currentIndex, qstack, questionnaireStep } = useSelector((state) => state.questionnaire);
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const profileData = {
    ...profile.condition_profile,
    ...profile.info,
    ...profile.personal,
  };

  const answeredQuestions = [...qstack].filter((q) => {
    const question = q.id === 'preferred_location' ? 'country' : q.id;
    const answer = profileData[question];
    if (Array.isArray(answer)) {
      return answer.length > 0;
    }
    return answer != null;
  });

  const skippedQuestions = [...qstack].slice(0, currentIndex).filter((q) => {
    const question = q.id === 'preferred_location' ? 'country' : q.id;
    const answer = profileData[question];
    if (Array.isArray(answer)) {
      return answer.length === 0;
    }
    return answer === null;
  });
  const allQuestions = answeredQuestions.length + skippedQuestions.length;

  useEffect(() => {
    const calcucatedProgress = calculateProgress(allQuestions, qstack.length);

    if (!(questionnaireStep === 'next' && progress > calcucatedProgress)) {
      setProgress(calcucatedProgress);
    }
  }, [allQuestions, progress, qstack, questionnaireStep]);

  return (
    <Grid className={classes.root}>
      <LinearProgress
        className={classes.linearProgress}
        variant="determinate"
        value={progress}
      />
    </Grid>
  );
};

QuestionnaireProgress.propTypes = {
  profile: PropTypes.object,
};

export default withTranslation()(QuestionnaireProgress);
